export const getInitialChars = (name: string) => {
  return name
    .split(" ")
    .map((namePart) => namePart.charAt(0))
    .join("");
};
